<template>
  <div class="entry">
    <div class="input-form-card">
      <div class="form-item">
        <label class="form-label">联系人</label>
        <el-input v-model="form.nickname" placeholder="请输入联系人" />
      </div>

      <div class="form-item">
        <label class="form-label">电话</label>
        <el-input
            v-model="form.phone"
            placeholder="请输入电话"
            maxlength="11"
        />
      </div>

      <div class="form-item">
        <label class="form-label">地址</label>
        <el-input v-model="form.address" placeholder="请输入地址" />
      </div>
      <div class="form-item">
        <label class="form-label">微信</label>
        <el-input v-model="form.wx" placeholder="请输入微信" />
      </div>

      <div class="form-item">
        <label class="form-label">机构名称</label>
        <el-input
            v-model="form.institution_name"
            placeholder="请输入机构名称"
        />
      </div>
      <div class="form-item">
        <label class="form-label">机构性质</label>
        <el-select
            v-model="form.institution_nature"
            placeholder="请选择机构性质"
        >
          <el-option label="英语类培训机构" value="英语类培训机构"> </el-option>
          <el-option label="阅读类培训机构" value="阅读类培训机构"> </el-option>
          <el-option label="艺体培训机构" value="艺体培训机构"> </el-option>
          <el-option label="幼儿园" value="幼儿园"> </el-option>
          <el-option label="K12学校" value="K12学校"> </el-option>
          <el-option label="其他" value="其他"> </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <label class="form-label">采购版本</label>
        <el-select v-model="form.level" placeholder="请选择采购版本">
          <el-option v-if="level > 1" label="采购版本A" :value="1"> </el-option>
          <el-option v-if="level > 2" label="采购版本B" :value="2"> </el-option>
          <el-option v-if="level > 3" label="采购版本C" :value="3"> </el-option>
          <el-option v-if="level > 4" label="采购版本D" :value="4"> </el-option>
          <el-option v-if="level > 5" label="采购版本E" :value="5"> </el-option>
          <el-option v-if="level > 6" label="采购版本F" :value="6"> </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <label class="form-label">合同图片</label>
        <div class="upload-box-list">
          <!-- 已上传的合同图片 -->
          <div
              v-for="(item, index) in contractList"
              :key="index"
              class="upload-box"
          >
            <img :src="item" class="preview-img"/>
            <span class="delete-btn" @click.stop="delContract(index)">×</span>
          </div>
          <!-- 新增上传按钮 -->
          <div class="upload-box add-box" @click="handleUpload('contract')">
            <div class="upload-icon">
              <img src="@/assets/picture.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="form-item">
        <label class="form-label">是否区域独家</label>
        <el-select v-model="form.regional_exclusive" placeholder="是否区域独家">
          <el-option label="是" :value="1"> </el-option>
          <el-option label="否" :value="0"> </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <label class="form-label">是否使用品牌</label>
        <el-select v-model="form.using_brand" placeholder="是否使用品牌">
          <el-option label="是" :value="1"> </el-option>
          <el-option label="否" :value="0"> </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <label class="form-label">备注</label>

        <el-input v-model="form.remark" placeholder="请输入备注" />
      </div>

      <div
          class="form-item"
          style="align-items: flex-start"
          v-if="checkAuth(1) || checkAuth(2)"
      >
        <label class="form-label">访问权限</label>
        <el-checkbox-group v-model="form.auth_node">
          <el-checkbox v-if="checkAuth(1)" label="1" value="1"
          >学习权限</el-checkbox
          >
          <el-checkbox v-if="checkAuth(2)" label="2" value="2"
          >招商权限</el-checkbox
          >
        </el-checkbox-group>
      </div>

      <div class="form-item" style="align-items: flex-start">
        <label class="form-label">课件查看权限</label>
        <el-checkbox-group v-model="form.auth_level">
          <el-checkbox v-if="checkAuthLevel(1)" label="1" value="1"
          >常规级别</el-checkbox
          >
          <el-checkbox v-if="checkAuthLevel(2)" label="2" value="2"
          >高端级别</el-checkbox
          >
        </el-checkbox-group>
      </div>

      <div class="form-btn-wrap">
        <button class="submit-btn" @click="submitForm">
          {{ form.id === 0 ? "客户信息录入" : "编辑客户信息录入" }}
        </button>
      </div>
    </div>


    <!-- 隐藏文件选择框 -->
    <input
        ref="fileInput"
        type="file"
        accept="image/*"
        style="display: none"
        @change="handleFileChange"
    />
  </div>
</template>

<script>
  import { upload, editApply, applyInfo } from "@/api/api";

  export default {
    name: "Entry",
    data() {
      return {
        level: 0,
        auth_level: [],
        userAuth: [],
        form: {
          id: 0,
          auth_node: [],
          nickname: "",
          phone: "",
          address: "",
          institution_name: "",
          wx: "",
          remark: "",
          using_brand: "",
          regional_exclusive: "",
          institution_nature: "",
          level: "",
          auth_level: [],
          contract_images: "",
        },
        preview: {
          id_card_img: "",
          live_img: "",
          transfer_img: "",
          user_img: "",
        },
        contractList: [],
        currentUploadType: "",
      };
    },
    mounted() {
      if (this.$route.query.id) {
        this.applyInfo(this.$route.query.id);
      }
      this.initUserAuth();
    },
    methods: {
      initUserAuth() {
        const authNode =
            JSON.parse(localStorage.getItem("userInfo")).auth_node || "";
        const auth_level =
            JSON.parse(localStorage.getItem("userInfo")).auth_level || "";
        this.level = JSON.parse(localStorage.getItem("userInfo")).level || "";
        if (!authNode) {
          this.userAuth = [];
          return;
        }
        // 适配你的格式：",1,2," → 转成 [1,2]
        this.userAuth = authNode
            .split(",")
            .filter((item) => item.trim() !== "") // 去掉空字符串
            .map(Number); // 转数字
        this.auth_level = auth_level
            .split(",")
            .filter((item) => item.trim() !== "") // 去掉空字符串
            .map(Number); // 转数字
        console.log("用户权限:", this.userAuth);
      },
      /** 【纯计算，无IO，极快】判断权限 */
      checkAuth(authCode) {
        return this.userAuth.includes(authCode);
      },
      checkAuthLevel(authCode) {
        return this.auth_level.includes(authCode);
      },
      applyInfo(id) {
        applyInfo(id).then((res) => {
          const data = res.data;
          Object.keys(this.form).forEach((key) => {
            if (data[key] !== undefined) this.form[key] = data[key];
          });
          if (data.contract_images) {
            this.contractList = data.contract_images.split("|");
          }
        });
      },

      // 点击上传
      handleUpload(type) {
        this.currentUploadType = type;
        this.$refs.fileInput.click();
      },

      // 选择文件 → 调用上传接口
      async handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        // 校验图片
        if (!file.type.startsWith("image/")) {
          this.$message.error("请上传图片格式");
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error("图片不能超过5MB");
          return;
        }

        try {
          // 拼接接口需要的 formData（参数名：file）
          const formData = new FormData();
          formData.append("file", file);

          // 调用上传接口 → 拿到返回的 url
          const res = await upload(formData);
          const url = res.data.url; // 按你接口实际返回结构修改

          // 根据类型赋值
          const type = this.currentUploadType;
          if (type === "contract") {
            // 合同：多张 push
            this.contractList.push(url);
          } else {
            // 单张图片
            this.preview[type] = url;
          }

          this.$message.success("上传成功");
        } catch (err) {
          this.$message.error("上传失败");
          console.error(err);
        }

        // 清空文件框
        this.$refs.fileInput.value = "";
      },


      // 删除合同图片
      delContract(index) {
        this.contractList.splice(index, 1);
      },

      async submitForm() {
        let form = JSON.parse(JSON.stringify(this.form));
        form["auth_node"] = form.auth_node.join(",");
        form["auth_level"] = form.auth_level.join(",");
        form["contract_images"] = this.contractList.join("|");
        console.log(form);
        // 非备注字段必填校验
        if (!this.form.nickname) {
          this.$message.error("请输入联系人");
          return;
        }
        if (!this.form.phone) {
          this.$message.error("请输入电话");
          return;
        }
        // 手机号正则校验 11位大陆手机号
        const phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(this.form.phone)) {
          this.$message.error("请输入正确的11位手机号");
          return;
        }
        if (!this.form.institution_nature) {
          this.$message.error("请选择机构性质");
          return;
        }
        if (this.form.using_brand === '') {
          this.$message.error("请选择是否使用品牌");
          return;
        }

        if (this.form.level === '') {
          this.$message.error("请选择采购版本");
          return;
        }
        if (this.form.regional_exclusive === '') {
          this.$message.error("请选择是否区域独家");
          return;
        }
        if (!this.form.institution_name) {
          this.$message.error("请输入机构名称");
          return;
        }
        if (!this.form.address) {
          this.$message.error("请输入地址");
          return;
        }
        if (!this.form.wx) {
          this.$message.error("请输入微信");
          return;
        }
        if (this.contractList.length === 0) {
          this.$message.error("请至少上传一张合同图片");
          return;
        }

        const submitData = { ...form };
        let res = await editApply(submitData);
        if (res.code == 1) {
          this.$message.success("提交成功");
          this.$router.push({ path: "/entryRecord" });
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .entry {
    width: 100%;
  }

  .input-form-card {
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    max-width: 680px;
    border: 1px solid #f1f1f1;
  }

  .form-item {
    margin-bottom: 28px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .form-label {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      text-align: left;
    }
  }

  .upload-box-list {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    .upload-title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 10px;
      text-align: left;
    }

    .upload-box {
      width: 120px;
      height: 120px;
      border: 1px dashed #d1d5db;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      .upload-icon {
        width: 40px;
        height: 40px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .preview-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
      }

      .delete-btn {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 18px;
        height: 18px;
        background: #f53f3f;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .add-box {
      border-style: dashed;
      border-color: #ccc;
    }
  }

  .form-btn-wrap {
    text-align: left;
  }

  .submit-btn {
    padding: 12px 28px;
    background: #4063e8;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background: #3352d1;
    }
  }
</style>
